import React from "react";
import { IP } from "../../../internalServer";
import assets from "../../../assets/assets";

function PdfViewActivity({ setMideaviewer, attachment }) {
    const helper = (a) => {
        let p = a?.replace(/^\./, "");
        p = IP + p;

        // Check if the attachment is a PDF
        const isPDF = p.toLowerCase().endsWith(".pdf");

        if (!isPDF) {
            // Return the original URL if it's a PDF
            return p;
        } else {
            // Return the Google Docs Viewer URL for other supported files
            const viewerURL = `https://docs.google.com/gview?url=${encodeURIComponent(
                p
            )}&embedded=true`;
            return viewerURL;
        }
    };
    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 999,
            }}
        >
            <div
                style={{
                    position: "absolute",
                    top: 60,
                    right: 50,
                    bottom: 20,
                    left: 50,
                    width: "80vw",
                    margin: "auto",
                    backgroundColor: "#fff",
                }}
            >
                <iframe
                    title="myFrame"
                    src={helper(attachment)}
                    style={{
                        width: "100%", // Adjust iframe width
                        height: "100%", // Adjust iframe height
                    }}
                />

                <img
                    className="absolute top-[-20px] right-[-25px] cursor-pointer w-7 bg-white rounded-full"
                    onClick={(e) => {
                        setMideaviewer(false)
                    }}
                    src={assets.CrossIcon}
                    alt="cross logo"
                ></img>
            </div>
        </div>
    );
}

export default PdfViewActivity;


